import React from 'react';
import { Button } from './Button';

interface AddManuallyButtonProps {
  onClick: () => void;
  disabled?: boolean;
  isLoading?: boolean;
  loadingText?: string;
  /** When true, shows "Cancel" instead of "Add Manually" */
  isActive?: boolean;
}

/**
 * AddManuallyButton - Centralized "Add Manually" button component
 *
 * Features:
 * - mobileTouch for 48px minimum touch target (WCAG accessibility)
 * - Toggle state support (shows "Cancel" when isActive is true)
 * - Matches the pattern of AIRecommendationsButton for consistent UX
 * - Status area is handled by parent ActionButtonGroup
 */
export const AddManuallyButton: React.FC<AddManuallyButtonProps> = ({
  onClick,
  disabled = false,
  isLoading = false,
  loadingText = 'Adding...',
  isActive = false,
}) => {
  return (
    <Button
      variant="secondary"
      onClick={onClick}
      disabled={disabled || isLoading}
      mobileTouch
    >
      {isLoading ? loadingText : isActive ? 'Cancel' : 'Add Manually'}
    </Button>
  );
};
